import { MassMessagesTab } from './MassMessagesTab';

interface FanslyMassMessagesTabProps {
  accountId: string;
}

/** Full Mass Messages shell shared with OnlyFans, with Fansly campaign routing. */
export function FanslyMassMessagesTab({ accountId }: FanslyMassMessagesTabProps) {
  return <MassMessagesTab accountId={accountId} platform="fansly" />;
}
